import controller from './vd-multiselect-popover.controller'
import template from './vd-multiselect-popover.html'

const MultiselectPopoverComponent = {
  bindings: {
    items: '<',
    key: '<',
    selectAllLabel: '<',
    countLabel: '<',
    placeholder: '<',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  controller,
  template,
}

export default MultiselectPopoverComponent
